﻿import $ from 'jquery';

class Application {
  static conventions: any;
  static conventionsReady: boolean;

  static convention(selector, wireup) {
    Application.conventions.push({ selector: selector, wireup: wireup });
  };

  static wireupConventions(element) {
    for (var i = 0; i < Application.conventions.length; i++) {
      var convention = Application.conventions[i];
      convention.wireup.call($(convention.selector, $(element)).addBack(convention.selector));
    }
  }
  static triggerConventionsReady() {
    if (Application.conventionsReady) {
      $(document).trigger('rustig.conventionsready');
    } else {
      setTimeout(Application.triggerConventionsReady, 50);
    }
  };
}
Application.conventions = [];
Application.conventionsReady = true;

export default Application;

